import clsx from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';

export interface SideOverHeadingProps extends Pick<ComponentPropsWithoutRef<'h1'>, 'className'> {
  heading: string;
}

export const SideOverHeading: FC<SideOverHeadingProps> = ({ heading, className }) => {
  return (
    <h1
      className={clsx(
        'mb-8 md:mb-14 md:mt-[25px] text-[34px] md:text-5xl font-bold leading-10 md:leading-normal tracking-normal  dark:text-white',
        className
      )}
    >
      {heading}
    </h1>
  );
};
